import { useEffect } from 'react';

/* Управление SEO-тегами в <head> для посадочных страниц. react-snap
   пререндерит страницы после выполнения JS, поэтому проставленные здесь
   теги попадают в статический HTML и индексируются поисковиками. */

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/* hreflang-альтернативы: удаляем прежние (помеченные data-seo-alt) и
   проставляем новый набор — перекрёстные ссылки ru / ru-BY / ru-KZ. */
function upsertAlternates(list) {
  document.head.querySelectorAll('link[rel="alternate"][data-seo-alt]').forEach(e => e.remove());
  (list || []).forEach(({ hreflang, href }) => {
    const el = document.createElement('link');
    el.setAttribute('rel', 'alternate');
    el.setAttribute('hreflang', hreflang);
    el.setAttribute('href', href);
    el.setAttribute('data-seo-alt', '1');
    document.head.appendChild(el);
  });
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) { if (el) el.remove(); return; }
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function useSeo({ title, description, canonical, image, jsonLd, alternates }) {
  const altKey = JSON.stringify(alternates || null);
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:locale', 'ru_RU');
    upsertMeta('property', 'og:site_name', 'Amorika');
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonical);
    if (image) upsertMeta('property', 'og:image', image);
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    if (image) upsertMeta('name', 'twitter:image', image);
    upsertMeta('name', 'robots', 'index, follow, max-snippet:-1, max-image-preview:large');
    if (canonical) upsertLink('canonical', canonical);
    upsertAlternates(alternates);
    upsertJsonLd('seo-ld', jsonLd);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title, description, canonical, image, jsonLd, altKey]);
}
